import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import Button from './ui/Button';
import { toast } from 'sonner';

const SendResetLink: React.FC = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [message, setMessage] = useState('');

	const handleSendLink = async (e: React.FormEvent) => {
		e.preventDefault();
		setIsLoading(true);
		setMessage('');
		try {
			const { error } = await supabase.auth.resetPasswordForEmail(email, {
				redirectTo: window.location.origin + '/reset-password',
			});
			if (error) {
				if (
					error.message.toLowerCase().includes('user') ||
					error.message.toLowerCase().includes('not found') ||
					error.message.toLowerCase().includes('no user')
				) {
					toast.error('User not found.');
					setMessage('User not found.');
				} else {
					toast.error(error.message);
					setMessage(error.message);
				}
			} else {
				setMessage('Password reset link sent! Please check your email.');
				toast.success('Password reset link sent! Please check your email.');
			}
		} catch (err) {
			toast.error('Could not send reset link. Try again.');
			setMessage('Could not send reset link. Try again.');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="min-h-screen bg-slate-100 flex items-center justify-center p-2">
			<div className="w-full max-w-md">
				<div className="bg-white rounded-2xl shadow-xl p-6 py-8">
					<h1 className="text-xl font-bold text-gray-900 mb-2 text-center">Forgot Password</h1>
					<p className="text-gray-600 mb-4 text-center">
						Enter your email address below and we'll send you a password reset link.
					</p>
					<form onSubmit={handleSendLink} className="space-y-5">
						<div>
							<label className="block text-xs font-medium text-gray-700 mb-1">Email Address</label>
							<input
								type="email"
								value={email}
								onChange={e => setEmail(e.target.value)}
								className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ghana-red focus:border-transparent transition-colors"
								placeholder="Enter your email"
								required
							/>
						</div>
						<Button
							type="submit"
							disabled={isLoading}
							className="w-full text-white font-semibold rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
						>
							{isLoading ? 'Sending...' : 'Send Reset Link'}
						</Button>
					</form>
					{message && <div className="mt-4 text-center text-sm text-brand-orange">{message}</div>}
					<div className="mt-4 text-center">
						<button
							onClick={() => navigate('/admin')}
							className="text-ghana-red hover:text-red-700 text-sm font-medium"
						>
							← Back to Login
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SendResetLink;
